import { rtkQueryApi } from './rtk-query-api';
import { type UserMeType } from '../slices/user-slice';

export const userApi = rtkQueryApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserMe: builder.query<UserMeType, void>({
      query: () => ({
        url: `${import.meta.env.VITE_REACT_COMMON_API_BASE_URL}/user/users/me`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetUserMeQuery, useLazyGetUserMeQuery } = userApi;